import SourcesAccountsPage from "@app/pages/sources/accounts";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

export const Route = createFileRoute("/_authed/sources_/accounts")({
  head: () => pageHead("Account mapping"),
  component: SourcesAccountsRoute,
});

function SourcesAccountsRoute() {
  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading account mapping</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading account mapping…</div>}
      >
        <SourcesAccountsPage />
      </Suspense>
    </ErrorBoundary>
  );
}
